// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2w-3";
export var dialog = "_2w-0";
export var divClassnameSwatch = "_2w-8";
export var flexSwatch = "_2w-4";
export var header = "_2w-1";
export var styleAttributeSwatch = "_2w-7";
export var swatch = "_2w-2";
export var textHeaderSwatch = "_2w-5";
export var webSwatch = "_2w-6";